// extracted by mini-css-extract-plugin
export default {"root":"yrYWe0vknD","title":"dBm7GnxaNV","subText":"nDCsHnTgJk"};